import request from '@/utils/request'

export const login = (data) => {
  return request.post('/v1/auth/login', data)
}

export const getUserInfo = () => {
  return request.get('/v1/auth/info')
}

export const logout = () => {
  return request.post('/v1/auth/logout')
}
